import React from 'react'

const Title = ({title, des}) => {
  return (
    <div className="flex flex-col gap-2 font-titleFont mb-8">
      <h3 className="text-xs uppercase font-light text-cyan-400 tracking-[4px]">
       {title}
      </h3>
      <h1 className="text-3xl md:text-4xl text-white font-bold capitalize">{des}</h1>
    </div>
  );
}

export default Title
